import GraphemeSplitter from 'grapheme-splitter'
import arrayCharacterFullWidth from './fullwidth'
import arrayCharacterHalfWidth from './halfwidth'

const splitter = new GraphemeSplitter()

const getCharacters = (string) => {
  return splitter.splitGraphemes(string)
}

const convertCharacter = (character, mode) => {
  let arrayCharacter
  if (mode === 'full') {
    arrayCharacter = arrayCharacterFullWidth
    const key = character
    if (typeof arrayCharacter[key] === 'undefined') {
      return character
    }
    return arrayCharacter[key]
  }

  if (mode === 'half') {
    arrayCharacter = arrayCharacterHalfWidth
    const key = character
    if (typeof arrayCharacter[key] === 'undefined') {
      return character
    }
    return arrayCharacter[key]
  }

  return character
}

export const convertToWidthCharacter = (string, mode) => {
  const characters = getCharacters(string)
  let convertString = ''
  characters.forEach((character) => {
    convertString += convertCharacter(character, mode)
  })

  return convertString.replace('　', ' ')
}

export const toHalfWidthNumber = (value) => {
  if (value == null || value === '') return null
  const digits = convertToWidthCharacter(String(value), 'half').replace(
    /[^0-9]/g,
    ''
  )
  return digits === '' ? null : digits
}

const romajiToKanaMap = {
  "a": "ア",
  "i": "イ",
  "u": "ウ",
  "e": "エ",
  "o": "オ",
  "ka": "カ",
  "ki": "キ",
  "ku": "ク",
  "ke": "ケ",
  "ko": "コ",
  "kya": "キャ",
  "kyi": "キィ",
  "kyu": "キュ",
  "kye": "キェ",
  "kyo": "キョ",
  "kwa": "クヮ",
  "kwi": "クィ",
  "kwu": "クゥ",
  "kwe": "クェ",
  "kwo": "クォ",
  "sa": "サ",
  "si": "シ",
  "su": "ス",
  "se": "セ",
  "so": "ソ",
  "sya": "シャ",
  "syi": "シ",
  "syu": "シュ",
  "sye": "シェ",
  "syo": "ショ",
  "sha": "シャ",
  "shi": "シ",
  "shu": "シュ",
  "she": "シェ",
  "sho": "ショ",
  "swa": "スァ",
  "swi": "スィ",
  "swu": "スゥ",
  "swe": "スェ",
  "swo": "スォ",
  "ta": "タ",
  "ti": "チ",
  "tu": "ツ",
  "te": "テ",
  "to": "ト",
  "tya": "チャ",
  "tyi": "チィ",
  "tyu": "チュ",
  "tye": "チェ",
  "tyo": "チョ",
  "tha": "テャ",
  "thi": "ティ",
  "thu": "テュ",
  "the": "テェ",
  "tho": "テョ",
  "tsa": "ツァ",
  "tsi": "ツィ",
  "tsu": "ツ",
  "tse": "ツェ",
  "tso": "ツォ",
  "ca": "カ",
  "ci": "シ",
  "cu": "ク",
  "ce": "セ",
  "co": "コ",
  "cha": "チャ",
  "chi": "チ",
  "chu": "チュ",
  "che": "チェ",
  "cho": "チョ",
  "cya": "チャ",
  "cyi": "チィ",
  "cyu": "チュ",
  "cye": "チェ",
  "cyo": "チョ",
  "qa": "クァ",
  "qi": "クィ",
  "qu": "ク",
  "qe": "クェ",
  "qo": "クォ",
  "na": "ナ",
  "ni": "ニ",
  "nu": "ヌ",
  "ne": "ネ",
  "no": "ノ",
  "nya": "ニャ",
  "nyi": "ニィ",
  "nyu": "ニュ",
  "nye": "ニェ",
  "nyo": "ニョ",
  "nwa": "ヌヮ",
  "nwi": "ヌィ",
  "nwu": "ヌゥ",
  "nwe": "ヌェ",
  "nwo": "ヌォ",
  "ha": "ハ",
  "hi": "ヒ",
  "hu": "フ",
  "he": "ヘ",
  "ho": "ホ",
  "hya": "ヒャ",
  "hyi": "ヒィ",
  "hyu": "ヒュ",
  "hye": "ヒェ",
  "hyo": "ヒョ",
  "fa": "ファ",
  "fi": "フィ",
  "fu": "フ",
  "fe": "フェ",
  "fo": "フォ",
  "fya": "フャ",
  "fyi": "フィ",
  "fyu": "フュ",
  "fye": "フェ",
  "fyo": "フョ",
  "ma": "マ",
  "mi": "ミ",
  "mu": "ム",
  "me": "メ",
  "mo": "モ",
  "mya": "ミャ",
  "myi": "ミィ",
  "myu": "ミュ",
  "mye": "ミェ",
  "myo": "ミョ",
  "ya": "ヤ",
  "yi": "イ",
  "yu": "ユ",
  "ye": "イェ",
  "yo": "ヨ",
  "ra": "ラ",
  "ri": "リ",
  "ru": "ル",
  "re": "レ",
  "ro": "ロ",
  "rya": "リャ",
  "ryi": "リィ",
  "ryu": "リュ",
  "rye": "リェ",
  "ryo": "リョ",
  "wa": "ワ",
  "wi": "ウィ",
  "wu": "ウ",
  "we": "ウェ",
  "wo": "ヲ",
  "ga": "ガ",
  "gi": "ギ",
  "gu": "グ",
  "ge": "ゲ",
  "go": "ゴ",
  "gya": "ギャ",
  "gyi": "ギィ",
  "gyu": "ギュ",
  "gye": "ギェ",
  "gyo": "ギョ",
  "za": "ザ",
  "zi": "ジ",
  "zu": "ズ",
  "ze": "ゼ",
  "zo": "ゾ",
  "zya": "ジャ",
  "zyi": "ジィ",
  "zyu": "ジュ",
  "zye": "ジェ",
  "zyo": "ジョ",
  "ja": "ジャ",
  "ji": "ジ",
  "ju": "ジュ",
  "je": "ジェ",
  "jo": "ジョ",
  "jya": "ジャ",
  "jyi": "ジィ",
  "jyu": "ジュ",
  "jye": "ジェ",
  "jyo": "ジョ",
  "da": "ダ",
  "di": "ヂ",
  "du": "ヅ",
  "de": "デ",
  "do": "ド",
  "dha": "デャ",
  "dhi": "ディ",
  "dhu": "デュ",
  "dhe": "デェ",
  "dho": "デョ",
  "dya": "ヂャ",
  "dyi": "ヂィ",
  "dyu": "ヂュ",
  "dye": "ヂェ",
  "dyo": "ヂョ",
  "ba": "バ",
  "bi": "ビ",
  "bu": "ブ",
  "be": "ベ",
  "bo": "ボ",
  "bya": "ビャ",
  "byi": "ビィ",
  "byu": "ビュ",
  "bye": "ビェ",
  "byo": "ビョ",
  "va": "ヴァ",
  "vi": "ヴィ",
  "vu": "ヴ",
  "ve": "ヴェ",
  "vo": "ヴォ",
  "vya": "ヴャ",
  "vyi": "ヴィ",
  "vyu": "ヴュ",
  "vye": "ヴェ",
  "vyo": "ヴョ",
  "pa": "パ",
  "pi": "ピ",
  "pu": "プ",
  "pe": "ペ",
  "po": "ポ",
  "pya": "ピャ",
  "pyi": "ピィ",
  "pyu": "ピュ",
  "pye": "ピェ",
  "pyo": "ピョ",
  "xa": "ァ",
  "xi": "ィ",
  "xu": "ゥ",
  "xe": "ェ",
  "xo": "ォ",
  "xya": "ャ",
  "xyi": "ィ",
  "xyu": "ュ",
  "xye": "ェ",
  "xyo": "ョ",
  "la": "ァ",
  "li": "ィ",
  "lu": "ゥ",
  "le": "ェ",
  "lo": "ォ",
  "lya": "ャ",
  "lyi": "ィ",
  "lyu": "ュ",
  "lye": "ェ",
  "lyo": "ョ",
  "ltu": "ッ",
  "xtu": "ッ",
  "ltsu": "ッ",
  "xtsu": "ッ",
  "n": "ン",
  "-": "ー"
}
export const romajiToKana = (romaji) => {
  let result = ""
  const lowerRomaji = romaji.toLowerCase()
  let i = 0
  while (i < lowerRomaji.length) {
    // Check case "ッ" (double consonant)
    if (i < lowerRomaji.length - 1 && lowerRomaji[i] === lowerRomaji[i + 1] && !['a', 'i', 'u', 'e', 'o', 'n'].includes(lowerRomaji[i])) {
      result += "ッ"
      i += 1
    } else {
      let match = null
      // Check from 4 characters down to 1 character
      for (let length = 4; length >= 1; length--) {
        if (i + length <= lowerRomaji.length) {
          const sub = lowerRomaji.substring(i, i + length)
          if (romajiToKanaMap[sub]) {
            match = romajiToKanaMap[sub]
            i += length
            break // Exit inner loop after match
          }
        }
      }
      if (match) {
        result += match
      } else {
        result += lowerRomaji[i]
        i++
      }
    }
  }
  return result
}
